import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import styles from './SimpleTextEditor.scss';

const isBrowser = typeof window !== 'undefined';
let ReactQuillEditor = null;

if (isBrowser) {
  require('react-quill/dist/quill.snow.css');
  ReactQuillEditor = require('react-quill');
}

class SimpleTextEditor extends React.Component {

  handleChange = (html) => {
    if (this.props.onChange) this.props.onChange(html);
  }

  render() {
    if (!ReactQuillEditor) return <div>Loading editor...</div>;

    const modules = {
      toolbar: [
        ['bold', 'italic', 'underline'],
        [{ 'align': [] }],
        ['clean']
      ]
    };

    return (
      <div className="my-editor">
        <ReactQuillEditor
          value={this.props.value}
          onChange={this.handleChange}
          modules={this.props.modules || modules}
          theme="snow"
        />
      </div>
    );
  }
}

export default withStyles(styles)(SimpleTextEditor);




// WEBPACK FOOTER //
// src/components/utils/SimpleTextEditor/SimpleTextEditor.js